import keyIssueItemConnector from "../key-issue-item-connector"
import KeyIssueEditItem from "./KeyIssueEditItem"

export default keyIssueItemConnector(KeyIssueEditItem)
